import React, { useRef, useState, useEffect } from 'react'
import { Card, Form, InputGroup, ListGroup, Popover, OverlayTrigger,
  Row, Col, CloseButton, Button, Stack, Alert } from 'react-bootstrap'
import { serGetChat, serSetSendChat, serSetComment, serGetTextNO,
  serSetSendEdit, serSetdelectcard, serSetLoveInfo, serSetdelectcom } from '../../axios';
import { useSelector } from 'react-redux';
//import MarkdownIt from 'markdown-it';
import langList from '../../utils/languagelist.json'
import markdownIt from 'markdown-it'

function strLimit(str,n){
  return str.length>=n ? str.slice(0,n)+'...' : str
}

// 文本a中是否包含b，分隔是“,”，返回true或false
function checkString(a,b) {
  const p1 = '^'+b+',';
  const regex1 = new RegExp(p1);
  const p2 = ','+b+',';
  const regex2 = new RegExp(p2);
  return regex1.test(a) || regex2.test(a)
}

// 比较当前时间与d时间对象是否是同一天
function isSameDay(d) {
  const currentTime = new Date();
  return currentTime.toDateString() === d.toDateString();
}

export default function Exchange() {
  // 控制弹窗显示
  const [popover1Show, setPopover1Show] = useState(false);
  const [popover2Show, setPopover2Show] = useState(false);
  const [popover3Show, setPopover3Show] = useState(false);
  const [popover4Show, setPopover4Show] = useState(null);
  const [popover5Show, setPopover5Show] = useState(null);
  // 控制选项显示
  const [formChecked, setFormChecked] = useState(false);
  // 输入框的值
  const [sendValue, setSendValue] = useState('');
  
  // 共享的全部信息
  const [sendBackInfo, setSendBackInfo] = useState([]);
  const [sendBackComment, setSendBackComment] = useState([]);
  // 信息对话框
  const [msgInfo, setMsgInfo] = useState('');
  // 协议信息对话框
  const [alertShow, setAlertShow] = useState(false);
  // 协议内容
  const [alertValue, setAlertValue] = useState('');
  // 共享协议选项
  const [treatyCheck,setTreatyCheck] = useState(false);
  // 放大的图片路径
  const [zoomImgPath,setZoomImgPath] = useState('');
  // 强行刷新
  const [refresh,setRefresh] = useState(false);

  // 当前发送内容的状态：0-发表；1-编辑；2-评论
  const sendStyle = useRef(0);

  // 输入框的REF
  const inputRef = useRef(null);
  // 当前剪贴板的图片URL
  const imageUrl= useRef(null);
  // 粘贴了的图片URL
  const image1Url = useRef(null);
  const image2Url = useRef(null);
  // 当前剪贴板的图片blob
  const imageBlob = useRef(null);
  // 准备发送的图片Blob
  const sendImageBlob = useRef([null,null]);
  // 单击的图标
  const imageClickNode = useRef(null);
  // 防止useEffect执行两次
  const hasFetched = useRef(false);
  // 当前评论或编辑的卡片序号
  const cIndex = useRef(0);
  // 当前删除评论序号
  const dIndex = useRef(0);

  const {usern,role}=useSelector((state)=>state.logininfo);
  const {lg}=useSelector((state)=>state.language);

  const md = new markdownIt({ html: true });

  useEffect(() => {
    if(hasFetched.current) return;
    serGetChat({})
    .then(res =>{
      const code=res.code;
      if(code===27){
        const data=res.data;
        setSendBackInfo(data[0]);
        setSendBackComment(data[1]);
      }else{
        setMsgInfo(`0${langList.public8[lg]}`);
      };
    })
    .catch(err =>{
      setMsgInfo('0'+err.message);
    });
    hasFetched.current = true
  }, []);

  // 表情图标窗口------------------------------------------------
  const popover1 = (
    <Popover id="popover-basic">
      <Popover.Body>
        <div className='overflow-auto' style={{ height: '200px' }}>
          <Row xs={6} className="g-2">
            {Array.from({ length: 60 }, (_, index) => (
              <Col key={`ex${index}`}>
                <img
                  src={`./meme/${index + 1}.png`}
                  alt="" style={{ width: '20px' }}
                  onClick={() => handleIconClick(index)}
                />
              </Col>
            ))}
          </Row>
        </div>
      </Popover.Body>
    </Popover>
  );
  // 显示和关闭表情图标窗口
  const handleontoggle1 = (nextShow) => {
    if (popover1Show === nextShow) return;
    setPopover1Show(nextShow);
  }
  // 单击表情图标
  function handleIconClick(index) {
    const input = inputRef.current;
    const startPos = input.selectionStart;
    const endPos = input.selectionEnd;
    const insetStr = '[<' + (index + 1) + '>]'
    const newValue = sendValue.substring(0, startPos) + insetStr + sendValue.substring(endPos);
    setSendValue(newValue);
    input.focus();
    const n = insetStr.length
    setTimeout(() => {
      input.setSelectionRange(startPos + n, startPos + n);
    }, 0);
    setPopover1Show(false);
  }
  // -----------------------------------------------------------

  
  // 显示插入图片1窗口
  const handleontoggle2 = (nextShow) => {
    if (popover2Show === nextShow) return;
    if (!popover2Show && sendStyle.current === 2) return;
    if (popover2Show) setPopover2Show(nextShow);
  };
  // 显示插入图片2窗口
  const handleontoggle3 = (nextShow) => {
    if (popover3Show === nextShow) return;
    if (!popover3Show && sendStyle.current === 2) return;
    if (popover3Show) setPopover3Show(nextShow);
  };
  // 单击图片图标事件
  const handleImageClick = async (e) => {
    if (sendStyle.current === 2) return;
    if (e===1 && popover2Show) return;
    if (e===2 && popover3Show) return;
    imageClickNode.current=e
    if(!sendImageBlob.current[e-1]){
      try {
        const clipboardItems = await navigator.clipboard.read();
        const item=clipboardItems[0]
        if (item.types[0].includes('image/')) {
          const blob = await item.getType('image/png' || 'image/jpeg');
          const iurl = URL.createObjectURL(blob);
          imageBlob.current=blob;
          imageUrl.current=iurl;
        }else{
          imageUrl.current=null;
          imageBlob.current=null;
        }
      } catch (error) {
        imageUrl.current=null;
        imageBlob.current=null;
      }
    }
    if (e===1) setPopover2Show(true);
    if (e===2) setPopover3Show(true);
  }
  // 单击图片放大事件
  const handleImgClick = (imgpath) => {
    setZoomImgPath(imgpath)
  }
  // 单击粘贴图片按钮事件
  function handlePasteImage(){
    const index=imageClickNode.current
    sendImageBlob.current[index-1]=imageBlob.current;
    if(index===1) {
      image1Url.current=imageUrl.current
      setPopover2Show(false);
    }
    if(index===2) {
      image2Url.current=imageUrl.current
      setPopover3Show(false);
    }
  };
  // 单击删除已经粘贴的图片按钮事件
  function handleDeleteImage(){
    const index=imageClickNode.current
    sendImageBlob.current[index-1]=null;
    if(index===1) {
      image1Url.current=null
      setPopover2Show(false);
    }
    if(index===2) {
      image2Url.current=null
      setPopover3Show(false);
    }
  };
  // 插入图片窗口------------------------------------------------
  const isok = (imageClickNode.current === 1 && popover2Show) || 
    (imageClickNode.current === 2 && popover3Show);
  const popover2 = (
    <Popover id="popover2-basic">
      <Popover.Body>
        {isok && (
          sendImageBlob.current[imageClickNode.current-1] ? (
            <div className='text-center'>
              <p>{langList.exchange1[lg]}</p>
              <Button variant="outline-primary" size="sm"
                onClick={handleDeleteImage}
              >{langList.exchange2[lg]}</Button>
            </div>
          ) : (
            imageUrl.current ? (
              <div className='text-center'>
                <img
                  src={imageUrl.current} alt=""
                  style={{ maxWidth: '160px',maxHeight: '200px' }}
                  className='mx-1 d-block'
                />
                <Button variant="outline-primary" size="sm" className='mt-3'
                  onClick={handlePasteImage}
                >{langList.exchange3[lg]}</Button>
              </div>
            ) : (
              <span>{langList.exchange4[lg]}</span>
            )
          )
        )}
      </Popover.Body>
    </Popover>
  );
  // -----------------------------------------------------------

  // 发送类型选项有三个：发表，评论和编辑----------------------------
  // 点击发表类型选项
  const handleCheckChange=() => {
    if(!formChecked) return
    sendStyle.current=0;
    setFormChecked(false);
    setSendValue('')
    inputRef.current.focus();
  }
  // 点击评论
  const handleCommentClick=(e) => {
    sendStyle.current=2;
    cIndex.current=e.currentTarget.getAttribute('cordid')*1
    setFormChecked(true);
    setSendValue('')
    inputRef.current.focus();
    setRefresh(!refresh)
  }
  // 点击编辑
  const handleEditClick=(e) => {
    sendStyle.current=1;
    cIndex.current=e.target.getAttribute('cordid')*1
    sendImageBlob.current[0]=null;
    sendImageBlob.current[1]=null;
    image1Url.current=null;
    image2Url.current=null;
    setFormChecked(true);
    setSendValue(sendBackInfo[cIndex.current].chcontent)
    inputRef.current.focus();
  }
  // ----------------------------------------------
  
  // 删除帖子弹窗-----------------------------------
  // 显示删除帖子的窗口
  const handleontoggle4 = (nextShow) => {
    if(!nextShow){
      setPopover4Show(null)
    };
  };
  // 单击删除帖子按钮
  const handleDeleteCard = () => {
    serSetdelectcard({name:usern,chatid:sendBackInfo[cIndex.current].id})
    .then(res =>{
      const code=res.code;
      if(code===31){
        const data=res.data;
        setSendBackInfo(data[0]);
        setSendBackComment(data[1]);
      }else{
        setMsgInfo(`0${langList.public8[lg]}`);
      };
    })
    .catch(err =>{
      setMsgInfo('0'+err.message);
    });
    setPopover4Show(null)
  }
  const handleCloseButton = (e) => {
    cIndex.current=e.target.getAttribute('cordid')
    if(!popover4Show){
      setPopover4Show(cIndex.current)
    }else{
      if(popover4Show===cIndex.current){
        setPopover4Show(null)
      }else{
        setPopover4Show(cIndex.current)
      }
    }
  }
  // 删除帖子弹窗
  const popover4 = (
    <Popover id="popover3-basic">
      <Popover.Body>
        <div className='text-center'>
          <p>{langList.exchange5[lg]}</p>
          <Button variant="outline-primary" size="sm"
            onClick={handleDeleteCard}
          >{langList.exchange6[lg]}</Button>
        </div>
      </Popover.Body>
    </Popover>
  );
  // ----------------------------------------------

  // 删除评论
  // 显示删除评论的窗口
  const handleontoggle5 = (nextShow) => {
    if(!nextShow){
      setPopover5Show(null)
    };
  };
  // 单击删除评论小图标
  const handledeleteComImg=(e) => {
    dIndex.current=e.target.getAttribute('comid')
    if(!popover5Show){
      setPopover5Show(dIndex.current)
    }else{
      if(popover5Show===dIndex.current){
        setPopover5Show(null)
      }else{
        setPopover5Show(dIndex.current)
      }
    }
  }
  // 单击删除评论按钮
  const handleDeleteComBtn=() => {
    serSetdelectcom({comid:dIndex.current,cirole:role})
    .then(res =>{
      const code=res.code;
      if(code===33){
        const data=res.data;
        setSendBackComment(data);
      }else{
        setMsgInfo(`0${langList.public8[lg]}`);
      };
    })
    .catch(err =>{
      setMsgInfo('0'+err.message);
    });
    setPopover5Show(null)
  }
  // 删除评论弹窗
  const popover5 = (
    <Popover id="popover4-basic">
      <Popover.Body>
        <div className='text-center'>
          <p>{langList.exchange7[lg]}</p>
          <Button variant="outline-primary" size="sm"
            onClick={handleDeleteComBtn}
          >{langList.exchange8[lg]}</Button>
        </div>
      </Popover.Body>
    </Popover>
  );
  // ----------------------------------------------

  // ----------------------------------------------
  // 压缩图片小于至100KB
  const compressImage = async (blob) => {
    return new Promise((resolve, reject) => {
      const maxSize = 100 * 1024; // 100KB
      if(blob.size<=maxSize) resolve(blob);
      const image = new Image();
      image.src = URL.createObjectURL(blob);
      image.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        const width = image.width;
        const height = image.height;
        let ratio = 1;
        if (blob.size > maxSize) {
          ratio = Math.sqrt(maxSize / blob.size);
        }
        canvas.width = width * ratio;
        canvas.height = height * ratio;
        ctx.drawImage(image, 0, 0, width, height, 0, 0, canvas.width, canvas.height);
        canvas.toBlob((compressedBlob) => {
          resolve(compressedBlob);
        }, blob.type, 0.7); 
      };
    });
  };
  // 发送数据到后端
  const sendChat = async () => {
    if (!treatyCheck) {
      setMsgInfo(`0${langList.exchange9[lg]}`);
      return;
    }
    if(msgInfo) return;
    try {
      if (sendStyle.current===0){
        if(!sendValue && !sendImageBlob.current[0] && !sendImageBlob.current[1]) return;
        if(curSendCardNumber(2)){
          setMsgInfo(`0${langList.exchange10[lg]}`);
          return;
        }
        const formData = new FormData();
        if (sendImageBlob.current[0] instanceof Blob) {
          const blob1 = await compressImage(sendImageBlob.current[0]);
          formData.append('image1', blob1,'image1.'+blob1.type.split('/')[1]);
        }
        if (sendImageBlob.current[1] instanceof Blob) {
          const blob2 = await compressImage(sendImageBlob.current[1]);
          formData.append('image2', blob2,'image2.'+blob2.type.split('/')[1]);
        }
        formData.append('chat', sendValue);
        formData.append('user', usern);
        // 发送请求
        serSetSendChat(formData)
        .then(res =>{
          const code=res.code;
          if(code===26){
            const data=res.data;
            setSendBackInfo(data);
            setMsgInfo(`1${langList.exchange11[lg]}`);
          }else if(code===36){
            setMsgInfo(`0${langList.exchange12[lg]}`);
          }else if(code===37){
            setMsgInfo(`0${langList.exchange13[lg]}`);
          }else if(code===38){
            setMsgInfo(`0${langList.exchange14[lg]}`);
          }else if(code===39){
            setMsgInfo(`0${langList.exchange15[lg]}`);
          }else{
            setMsgInfo(`0${langList.public8[lg]}`);
          };
        })
        .catch(err =>{
          setMsgInfo('0'+err.message);
        });
      }else if(sendStyle.current===1){
        if(sendValue===sendBackInfo[cIndex.current].chcontent && 
          sendImageBlob.current[0]===null && sendImageBlob.current[1]===null) return;
        const formData = new FormData();
        if (sendImageBlob.current[0] instanceof Blob) {
          const blob1 = await compressImage(sendImageBlob.current[0]);
          formData.append('image1', blob1,'image1.'+blob1.type.split('/')[1]);
        }
        if (sendImageBlob.current[1] instanceof Blob) {
          const blob2 = await compressImage(sendImageBlob.current[1]);
          formData.append('image2', blob2,'image2.'+blob2.type.split('/')[1]);
        }
        formData.append('chat', sendValue);
        formData.append('user', usern);
        formData.append('chatid', sendBackInfo[cIndex.current].id);

        serSetSendEdit(formData)
        .then(res =>{
          const code=res.code;
          if(code===30){
            const data=res.data;
            setSendBackInfo(data);
            setMsgInfo(`1${langList.exchange16[lg]}`);
          }else if(code===36){
            setMsgInfo(`0${langList.exchange17[lg]}`);
          }else if(code===37){
            setMsgInfo(`0${langList.exchange18[lg]}`);
          }else if(code===38){
            setMsgInfo(`0${langList.exchange19[lg]}`);
          }else if(code===39){
            setMsgInfo(`0${langList.exchange20[lg]}`);
          }else{
            setMsgInfo(`0${langList.public8[lg]}`);
          };
        })
        .catch(err =>{
          setMsgInfo('0'+err.message);
        });
      }else{
        if(!sendValue) return;
        if(curSendComNumber(5)){
          setMsgInfo(`0${langList.exchange21[lg]}`);
          return;
        }
        serSetComment({name:usern,content:sendValue,
          chatid:sendBackInfo[cIndex.current].id})
        .then(res =>{
          const code=res.code;
          if(code===28){
            const data=res.data;
            setSendBackComment(data);
            setMsgInfo(`1${langList.exchange22[lg]}`);
          }else if(code===36){
            setMsgInfo(`0${langList.exchange23[lg]}`);
          }else if(code===37){
            setMsgInfo(`0${langList.exchange24[lg]}`);
          }else if(code===38){
            setMsgInfo(`0${langList.exchange25[lg]}`);
          }else if(code===39){
            setMsgInfo(`0${langList.exchange26[lg]}`);
          }else{
            setMsgInfo(`0${langList.public8[lg]}`);
          };
        })
        .catch(err =>{
          setMsgInfo('0'+err.message);
        });
      };
      sendStyle.current=0;
      sendImageBlob.current[0]=null;
      sendImageBlob.current[1]=null;
      image1Url.current=null;
      image2Url.current=null;
      setFormChecked(false);
      setSendValue('')
      inputRef.current.focus();
    } catch (err) {
      setMsgInfo('0'+err.message);
    };
  };
  // ----------------------------------------------

  // 点击贴子用户名复制到剪贴板
  const handleNameClick= async (e)=>{
    const cardId=e.target.getAttribute('cordid');
    try{
      await navigator.clipboard.writeText(sendBackInfo[cardId].chatname)
      setMsgInfo(`1${langList.exchange27[lg]}`)
    } catch (err) {
      setMsgInfo(`0${langList.exchange28[lg]}`)
    }
  }
  // 点击评论用户名复制到剪贴板
  const handleComNameClick= async (e)=>{
    const comName=e.target.getAttribute('comname');
    try{
      await navigator.clipboard.writeText(comName)
      setMsgInfo(`1${langList.exchange27[lg]}`)
    } catch (err) {
      setMsgInfo(`0${langList.exchange28[lg]}`)
    }
  }

  // 显示交流协议
  const handleTreatyClick = () => {
    serGetTextNO({txt:lg+'1'})
    .then(res =>{
      setAlertValue(res.data);
      setAlertShow(true);
    })
    .catch(err =>{
      console.log(err.message);
    });
  }

  // 点击爱心
  const handleLoveBtnClick=(e) => {
    const cardIndex=e.target.getAttribute('cordid')*1
    const loveStr=sendBackInfo[cardIndex].chlove;
    const chatid=sendBackInfo[cardIndex].id
    const name=usern.split('@')[0]
    if(!checkString(loveStr,name)){
      serSetLoveInfo({name,chatid})
      .then(res =>{
        const code=res.code;
        if(code===32){
          const data=res.data;
          setSendBackInfo(data);
        }else{
          setMsgInfo(`0${langList.public8[lg]}`);
        };
      })
      .catch(err =>{
        setMsgInfo('0'+err.message);
      });
    }
  }

  // 解析文本中的图标
  function compileStr(str){
    const contentArray = str.split(/(\[<\d+>\])/).filter(Boolean);
    return contentArray.map((f, k) => {
      const match = f.match(/\[<(\d+)>\]/);
      if (match) {
        // 如果匹配，渲染图片
        const imgNum = match[1];
        return (
          <span key={k} dangerouslySetInnerHTML={
            { __html: `<img src='./meme/${imgNum}.png' alt='' style='width:20px'/>` }
          }/>
        );
      } else {
        // 如果不匹配，渲染文本
        return <span key={k}>{f}</span>;
      };
    })
  }

  // 提示框
  const chip=(
    <Alert show={msgInfo===''?false:true} 
      variant={msgInfo.substring(0,1)==='0'?'danger':'success'} 
      className='py-1 text-center position-absolute text-danger w-100'
    >
      {msgInfo.substring(1)}
    </Alert>
  )

  if(msgInfo){
    setTimeout(() => {
      setMsgInfo('');
    }, 5000);
  };

  function backImageSrc (n){
    switch (sendStyle.current) {
      case 2:
        return './pic/image2.svg';
      case 1:
        if(sendImageBlob.current[n-1]){
          if(n===1){
            return image1Url.current;
          }else if(n===2){
            return image2Url.current;
          }
        }else{
          const imgn=sendBackInfo[cIndex.current][`chpic${n}`]
          if(imgn){
            return `./images/${imgn}`
          }else{
            return './pic/image.svg'
          }
        };
        break;
      default:
        if(n===1){
          return image1Url.current || './pic/image.svg';
        }else{
          return image2Url.current || './pic/image.svg';
        }
    }
  }

  // 当天是否发表了n个帖子
  function curSendCardNumber(n){
    let num=0;
    sendBackInfo.forEach((v) => {
      const cardDate=new Date(v.chtime)
      if (usern===v.chatname && isSameDay(cardDate)) {
        num +=1
      }
    })
    return num>=n;
  }

  // 一个贴子是否发现了n个评论
  function curSendComNumber(n){
    let num=0;
    sendBackComment.forEach((f)=>{
      if(sendBackInfo[cIndex.current].id===f.comchatid && usern===f.comname){
        num +=1
      }
    });
    return num>=n
  }

  function getTimeDiff(oldDate) {
    var currentDate = new Date();
    var diff = currentDate - oldDate;
    var seconds = Math.floor(diff / 1000);
    var minutes = Math.floor(seconds / 60);
    var hours = Math.floor(minutes / 60);
    var days = Math.floor(hours / 24);
    var months = Math.floor(days / 30);
    var years = Math.floor(months / 12);
    if (seconds < 60) {
        return seconds + 
        (seconds===1
        ? ` ${langList.exchange41[lg]}`
        : ` ${langList.exchange35[lg]}`);
    } else if (minutes < 60) {
        return minutes + 
        (minutes===1
        ? ` ${langList.exchange42[lg]}`
        : ` ${langList.exchange36[lg]}`);
    } else if (hours < 24) {
        return hours + 
        (hours===1
        ? ` ${langList.exchange43[lg]}`
        : ` ${langList.exchange37[lg]}`);
    } else if (days < 31) {
        return days + 
        (days===1
        ? ` ${langList.exchange44[lg]}`
        : ` ${langList.exchange38[lg]}`);
    } else if (months < 12) {
        return months + 
        (months===1
        ? ` ${langList.exchange45[lg]}`
        : ` ${langList.exchange39[lg]}`);
    } else {
        return years + 
        (years===1
        ? ` ${langList.exchange46[lg]}`
        : ` ${langList.exchange40[lg]}`);
    }
  };

  return (
    <div className='position-relative'>
      <div className='overflow-auto' style={{ height: '400px' }}>
        {sendBackInfo.map((v,i) => {
          const name=strLimit(v.chatname.split('@')[0],11)
          return(
            <Card className='mb-2' key={'chat'+i}>
              <Card.Header className='d-flex justify-content-between'>
                <div>
                  {usern===v.chatname &&
                  <img 
                    src='./pic/pencil-square1.svg'
                    alt='' width={'20px'}
                    className='me-2'
                    style={{cursor:'pointer'}}
                    onMouseOver={(e) => e.currentTarget.src = './pic/pencil-square2.svg'}
                    onMouseOut={(e) => e.currentTarget.src = './pic/pencil-square1.svg'}
                    onClick={handleEditClick}
                    cordid={i}
                  />}
                  { role==='competent'
                    ? <span className='fw-bold' style={{cursor:'pointer'}}
                        onClick={handleNameClick} cordid={i}
                      >{name}</span>
                    : <span className='fw-bold'>{name}</span>
                  }
                  <small className='mx-2'>{getTimeDiff(new Date(v.chtime))}</small>
                </div>
                {(usern===v.chatname || role==='competent') &&
                <OverlayTrigger trigger="click" placement="left" rootClose="true"
                  overlay={popover4} show={popover4Show===i.toString()}
                  onToggle={handleontoggle4}
                >
                  <CloseButton cordid={i} onClick={handleCloseButton}/>
                </OverlayTrigger>}
              </Card.Header>
              <Card.Body>
                <Card.Text>
                  {compileStr(v.chcontent)}
                </Card.Text>
                {v.chpic1 && <img src={`./images/${v.chpic1}`}
                  alt="" width='130px' className='mx-1'
                  style={{cursor:'pointer'}}
                  onClick={()=>{handleImgClick(`./images/${v.chpic1}`)}}
                />}
                {v.chpic2 && <img src={`./images/${v.chpic2}`}
                  alt="" width='130px' className='mx-1'
                  style={{cursor:'pointer'}}
                  onClick={()=>{handleImgClick(`./images/${v.chpic2}`)}}
                />}
                <ListGroup variant="flush" className='mt-4'>
                  {sendBackComment.map((f,k) => {
                    return(
                    f.comchatid===v.id && (
                      <ListGroup.Item className='px-0' key={'#'+v.id+k}>
                        <div className='d-flex justify-content-between'>
                          { role==='competent'
                            ? <small className='fw-bold me-2' style={{cursor:'pointer'}}
                                onClick={handleComNameClick} comname={f.comname}
                              >{f.comname.split('@')[0]}</small>
                            : <small className='fw-bold me-2'>{f.comname.split('@')[0]}</small>
                          }
                          {(usern===v.chatname||usern===f.comname||role==='competent') &&
                          <OverlayTrigger trigger="click" placement="left" rootClose="true"
                          overlay={popover5} show={popover5Show===f.id.toString()}
                          onToggle={handleontoggle5}>
                            <img src='./pic/x.svg' alt='' width={'16px'}
                            style={{cursor:'pointer'}}
                            onMouseOver={(e) => e.currentTarget.src = './pic/x-square2.svg'}
                            onMouseOut={(e) => e.currentTarget.src = './pic/x.svg'}
                            onClick={handledeleteComImg} comid={f.id}/>
                          </OverlayTrigger>}
                        </div>
                        <div>
                          <small>{compileStr(f.comcontent)}</small>
                        </div>
                      </ListGroup.Item>
                    ))
                  })}
                </ListGroup>
              </Card.Body>
              <Card.Footer className='d-flex justify-content-between'>
                <div>
                  <small>{v.chlove?v.chlove.match(/,/g).length:0}</small>
                  <img alt="" className='ms-1 pb-1'
                    src={
                      checkString(v.chlove,usern.split('@')[0])
                      ?'./pic/heart-fill.svg'
                      :'./pic/heart.svg'
                    }
                    style={{cursor:'pointer'}} cordid={i}
                    onClick={handleLoveBtnClick}
                  />
                </div>
                <div style={{cursor:'pointer'}} cordid={i}
                  onClick={handleCommentClick}
                >
                  <img alt='' src='./pic/chat-dots.svg'/>
                </div>
              </Card.Footer>
            </Card>
          )
        })}
      </div>
      <div style={{ backgroundColor: '#e8e8e8' }}>
        <div className='d-flex justify-content-start align-items-center'>
          <OverlayTrigger trigger="click" placement="top" rootClose="true"
            overlay={popover1} show={popover1Show}
            onToggle={handleontoggle1}
          >
            <img src='./pic/emoji-smile.svg' alt='' width={'20px'} className='m-2'
              style={{ cursor: 'pointer' }}
            />
          </OverlayTrigger>
          <OverlayTrigger trigger="click" placement="top" rootClose="true"
            overlay={popover2} show={popover2Show}
            onToggle={handleontoggle2}
          >
            <img alt='' width={'20px'} height={'20px'} className='m-2'
              src={backImageSrc(1)} 
              style={sendStyle.current!==2
                ? image1Url.current
                  ? { cursor: 'pointer', border: '1px solid black'}
                  : { cursor: 'pointer' }
                : { cursor: 'default' }
              }
              onClick={()=>handleImageClick(1)}
            />
          </OverlayTrigger>
          <OverlayTrigger trigger="click" placement="top" rootClose="true"
            overlay={popover2} show={popover3Show}
            onToggle={handleontoggle3}
          >
            <img alt='' width={'20px'} height={'20px'} className='m-2'
              src={backImageSrc(2)}
              style={sendStyle.current!==2
                ? image2Url.current
                  ? { cursor: 'pointer', border: '1px solid black'}
                  : { cursor: 'pointer' }
                : { cursor: 'default' }
              }
              onClick={()=>handleImageClick(2)}
            />
          </OverlayTrigger>
          <Form.Check
            type="switch" id="custom-switch"
            label={
              sendStyle.current===0?`${langList.exchange29[lg]}`:
              sendStyle.current===1?`${langList.exchange30[lg]}`:
              sendStyle.current===2?`${langList.exchange31[lg]}: `+
                strLimit(sendBackInfo[cIndex.current].chatname.split('@')[0],12):''
            }
            className='m-2'
            checked={formChecked}
            onChange={handleCheckChange}
          />
        </div>
        <InputGroup className="mb-1">
          <Form.Control
            id='send'
            type='text'
            as="textarea" 
            value={sendValue}
            onChange={(e) => setSendValue(e.target.value)}
            ref={inputRef}
          />
          <InputGroup.Text style={{cursor: 'pointer'}} onClick={sendChat}>
            <img src='./pic/send.svg' alt='' />
          </InputGroup.Text>
        </InputGroup>
      </div>
      <div className='position-relative'>
        {msgInfo && chip}
        <Stack direction="horizontal" gap={0}>
          <Form.Check
            id='communication'
            type='checkbox'
            label={langList.exchange34[lg]}
            checked={treatyCheck}
            onChange={() => {setTreatyCheck(!treatyCheck)}}
          />
          <Button variant="link" className='px-0'
            onClick={handleTreatyClick}
          >{langList.exchange33[lg]}</Button>
        </Stack>
      </div>
      <Alert
        variant="light"
        show={alertShow}
        onClose={() => setAlertShow(false)} 
        dismissible
        className='position-absolute h-100 pe-3'
        style={{ top: 0, left: 0, zIndex: 1 }}
      >
        <Alert.Heading>&nbsp;</Alert.Heading>
        <div className='overflow-auto' style={{ height: '445px'}}>
          {/* <ReactMarkdown>{alertValue}</ReactMarkdown> */}
          <div dangerouslySetInnerHTML={{ __html: md.render(alertValue) }} />
        </div>
      </Alert>
      {zoomImgPath &&
      <Alert
        variant="light"
        show={true}
        onClose={() => setZoomImgPath('')} 
        dismissible
        className='position-absolute h-100 px-0'
        style={{ top: 0, left: 0, zIndex: 2}}
      >
        <div className='h-100 d-flex justify-content-center align-items-center '>
          <img src={zoomImgPath}
            alt="" className='mx-1 w-100'
          />
        </div>
      </Alert>}
    </div>
  )
};

